import { axiosInstance } from '../../api/api';

export const platePunchingInitiate = (
	sequenceNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/station/label/PLATE_PUNCH/${sequenceNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};


export const engravingInitiate = (
	sequenceNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/station/label/ENGRAVE/${sequenceNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

export const getEngravingStatus = (
	sequenceNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/station/label/ENGRAVE/${sequenceNumber}/status`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

export const skipEngraving = (
	sequenceNumber,
	payload,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.post(`/station/label/ENGRAVE/${sequenceNumber}/skip`, payload)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};
